import { createStore } from 'vuex';

export interface State {
  language: string;
}

const state: State = {
  language: 'cn', // Default language
};

export default createStore({
  state,
  mutations: {
    setLanguage(state, lang: string) {
      state.language = lang;
    },
  },
  getters: {
    language: (state) => state.language,
  },
});
